export default __webpack_public_path__ + "static/media/b28.cec85387.png";